import { Mode, tokens, fonts } from "./theme";
import { useLanguage } from "@/contexts/LanguageContext";
import beamyImg from "@/assets/beamy.png";

interface Props { mode?: Mode }

const BeamyChatMockup = ({ mode = "dark" }: Props) => {
  const T = tokens(mode);
  const { t } = useLanguage();

  const bubbleUser = { background: T.accent, color: T.accentInk, borderRadius: "18px 18px 4px 18px", padding: "10px 14px", fontSize: 12, lineHeight: 1.5, maxWidth: "78%", marginLeft: "auto" };
  const bubbleBot = { background: T.surface, border: `1px solid ${T.border}`, color: T.text, borderRadius: "18px 18px 18px 4px", padding: "10px 14px", fontSize: 12, lineHeight: 1.5, maxWidth: "78%" };
  const avatarStyle = { width: 26, height: 26, borderRadius: 999, overflow: "hidden", flexShrink: 0 } as const;

  return (
    <div style={{ background: T.bg, color: T.text, fontFamily: fonts.ui, height: "100%", padding: "56px 20px 28px", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 18, paddingBottom: 14, borderBottom: `1px solid ${T.border}` }}>
        <button style={{ width: 28, height: 28, borderRadius: 8, border: "none", background: T.surface, color: T.text, fontSize: 13, cursor: "pointer", fontFamily: fonts.ui }}>←</button>
        <div style={{ ...avatarStyle }}><img src={beamyImg} alt="Beamy" style={{ width: "100%", height: "100%", objectFit: "cover" }} /></div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 14, fontWeight: 700, display: "flex", alignItems: "center", gap: 5 }}>
            Beamy <span style={{ width: 7, height: 7, borderRadius: 999, background: T.ok, display: "inline-block" }} />
          </div>
          <div style={{ fontSize: 9, color: T.textDim }}>{t("mock.chat.subtitle")}</div>
        </div>
        <div style={{ fontSize: 16, color: T.textDim, letterSpacing: 2 }}>•••</div>
      </div>

      {/* Chat messages */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 10, overflow: "hidden" }}>
        {/* User message */}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <div style={bubbleUser}>{t("mock.chat.user1")}</div>
        </div>

        {/* Bot reply */}
        <div style={{ display: "flex", alignItems: "flex-end", gap: 6 }}>
          <div style={{ ...avatarStyle, width: 22, height: 22 }}><img src={beamyImg} alt="Beamy" style={{ width: "100%", height: "100%", objectFit: "cover" }} /></div>
          <div style={bubbleBot}>{t("mock.chat.bot1")}</div>
        </div>

        {/* User reply */}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <div style={bubbleUser}>{t("mock.chat.user2")}</div>
        </div>

        {/* Bot reply */}
        <div style={{ display: "flex", alignItems: "flex-end", gap: 6 }}>
          <div style={{ ...avatarStyle, width: 22, height: 22 }}><img src={beamyImg} alt="Beamy" style={{ width: "100%", height: "100%", objectFit: "cover" }} /></div>
          <div style={bubbleBot}>{t("mock.chat.bot2")}</div>
        </div>

        {/* Bot follow-up */}
        <div style={{ display: "flex", alignItems: "flex-end", gap: 6 }}>
          <div style={{ width: 22, flexShrink: 0 }} />
          <div style={bubbleBot}>{t("mock.chat.bot3")}</div>
        </div>

        {/* Quick replies */}
        <div style={{ display: "flex", alignItems: "flex-end", gap: 6 }}>
          <div style={{ ...avatarStyle, width: 22, height: 22 }}><img src={beamyImg} alt="Beamy" style={{ width: "100%", height: "100%", objectFit: "cover" }} /></div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
            {["mock.chat.chip1", "mock.chat.chip2"].map((key) => (
              <div key={key} style={{ background: T.surface, border: `1px solid ${T.accent}`, color: T.accent, borderRadius: 999, padding: "6px 12px", fontSize: 10, fontWeight: 600, cursor: "pointer" }}>
                {t(key)}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Action bar */}
      <div style={{ display: "flex", gap: 6, marginTop: 10, overflowX: "auto", paddingBottom: 4 }}>
        {["mock.chat.action1", "mock.chat.action2", "mock.chat.action3"].map((key) => (
          <div key={key} style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 999, padding: "7px 12px", fontSize: 10, fontWeight: 600, color: T.text, whiteSpace: "nowrap", display: "flex", alignItems: "center", gap: 4 }}>
            {t(key)}
          </div>
        ))}
      </div>

    </div>
  );
};

export default BeamyChatMockup;
